import { useParams } from 'react-router-dom'
import { isUuid } from '@/utils/uuid'

/**
 * Render `element` only when the route param `param` is a record id. Any
 * other segment (`/metrics/categories`, `/metrics/42`) gets `fallback`, so a
 * mistyped or guessed path shows the 404 page instead of firing record
 * requests that can only fail.
 */
export default function UuidParamGuard({ param, element, fallback }) {
  const value = useParams()[param]
  return isUuid(value) ? element : fallback
}
